export const NOTIFICATION_CHECK_INTERVAL_MS = 30 * 60 * 1000

const taipeiClock = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Taipei',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
})

export function isWithinNotificationWindow(now: Date) {
  const parts = Object.fromEntries(
    taipeiClock.formatToParts(now).map((part) => [part.type, part.value]),
  )
  const seconds = Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second)
  return seconds >= 7 * 3600 && seconds <= 19 * 3600
}

export function shouldCheckNotifications(now: Date, lastCheckedAt: string | null, force = false) {
  if (force) return true
  if (!isWithinNotificationWindow(now)) return false
  if (!lastCheckedAt) return true
  const elapsed = now.getTime() - new Date(lastCheckedAt).getTime()
  return !Number.isFinite(elapsed) || elapsed >= NOTIFICATION_CHECK_INTERVAL_MS
}
